<template>
  <router-link class="bouton" :to="{ name: 'Quizz' }">Jeu</router-link>
  <br /><br />
  <router-link class="bouton" :to="{ name: 'Study' }">Révision</router-link>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
